export enum Status {
  LOADING = 'loading',
  ERROR = 'error',
  COMPLETE = 'complete',
  NO_DATA = 'no_data',
  NOT_AVAILABLE = 'not_available',
}
